import { createAction, props } from '@ngrx/store';
import { UserLogin } from '../models/user-login';
import { User } from '../../administration-managment/models/user';
import { Token } from '../models/token';

export const loginUser = createAction('LOGIN_USER', props<{ username: string, password: string }>());
export const loginMicrosoft = createAction('LOGIN_MICROSOFT', props<Token>());
export const loginSuccess = createAction('LOGIN_SUCCESS', props<UserLogin>());
export const logoutUser = createAction('LOGOUT_USER', props<User>());
export const refreshToken = createAction('REFRESH_TOKEN', props<UserLogin>());
export const logoutMicrosoft = createAction('LOGOUT_MICROSOFT', props<User>());
export const getUserData = createAction('GET_USER_DATA');
export const getUserDataSuccess = createAction(
  'GET_USER_DATA_SUCCESS',
  props<User>()
);


